(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-brand-value"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-brand-value-script')
    if (!window.brandValues && $url && $url.dataset.designMode !== 'yes') {
      window.brandValues = $url.value

      var $script = document.createElement('script')
      $script.src = window.brandValues
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advertorial-product-form"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finishes-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-finishes-gallery-script')
    if (!window._finishesGallery && $url && $url.dataset.designMode !== 'yes') {
      window._finishesGallery = $url.value
      var $script = document.createElement('script')
      $script.src = window._finishesGallery
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-highlight-cards-script')
    if (!window.highlightCards && $url && $url.dataset.designMode !== 'yes') {
      window.highlightCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.highlightCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpNeos-main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpNeos-product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpT04-main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpT04-product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neos-ll-pdp-card-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-neos-ll-pdp-script');
    if (!window._neosllPdp && $url) {
      window._neosllPdp = $url.value;
      var $script = document.createElement('script');
      $script.src = window._neosllPdp;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
    let waitSwiperJs = (callback, flag, loopCount)=>{
      loopCount = loopCount || 0;
      if(!flag) {
        console.log("Try to locate `Swiper`...");
      } else {
        console.log("Retry to locate `Swiper`...");
      }
      if(!window.Swiper) {
        if(loopCount > 100) {
          if(window.tick_20250430155855) { clearTimeout(window.tick_20250430155855); }
          console.log("Failed to locate `Swiper`...");
          return;
        }
        if(window.tick_20250430155855) { clearTimeout(window.tick_20250430155855); }
        window.tick_20250430155855 = setTimeout(()=>{
          waitSwiperJs(callback, true, loopCount + 1);
        }, 100);
      } else {
        console.log("Locate `Swiper` successfully.");
        callback.call();
      }
    };
    let loadSwiper = () => {
      if(!window.Swiper) return;
      let swiper = new Swiper(".nlpcv-swiper-container", {
        /*centeredSlides: true,*/
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
        },
        /*navigation: {
          nextEl: ".nlpcv-swiper-button-next",
          prevEl: ".nlpcv-swiper-button-prev",
        },*/
        on: {
          slideChange: function() {
            /*
            if(document.querySelector(".neos-ll-pdp-container.infomation-container")) {
              if(this.realIndex == 0) {
                document.querySelector(".neos-ll-pdp-container.infomation-container").classList.remove("d-none");
              } else {
                document.querySelector(".neos-ll-pdp-container.infomation-container").classList.add("d-none");
              }
            }
            */
          }
        }
      });
    };
    document.addEventListener('DOMContentLoaded', ()=>{waitSwiperJs(loadSwiper);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["referral"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-referral-script')
    if (!window.brandValues && $url && $url.dataset.designMode !== 'yes') {
      window.brandValues = $url.value

      var $script = document.createElement('script')
      $script.src = window.brandValues
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-coupon-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('secondary-coupon-hero')) {
    class SecondaryCouponHero extends HTMLElement {
      connectedCallback() {
        this.copyButton = this.querySelector('[data-coupon-copy]');
        this.copyText = this.querySelector('[data-copy-text]');
        this.copyStatus = this.querySelector('[aria-live]');
        this.deviceOptions = Array.from(this.querySelectorAll('[data-device-option]'));
        this.mediaLayers = Array.from(this.querySelectorAll('[data-device-media]'));
        this.cta = this.querySelector('[data-pdp-cta]');
        this.ctaText = this.querySelector('[data-cta-text]');
        this.handleBlockSelect = (event) => {
          const option = this.deviceOptions.find((item) => item.dataset.deviceId === event.detail.blockId);
          if (option) this.selectDevice(option);
        };

        this.copyButton?.addEventListener('click', () => this.copyCoupon());
        this.deviceOptions.forEach((option) => {
          option.querySelector('input')?.addEventListener('change', () => this.selectDevice(option));
        });
        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        const selected = this.deviceOptions.find((option) => option.querySelector('input')?.checked);
        if (selected) this.selectDevice(selected);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        window.clearTimeout(this.copyResetTimer);
      }

      async copyCoupon() {
        const targetId = this.copyButton?.dataset.copyTarget;
        const code = targetId ? document.getElementById(targetId)?.textContent?.trim() : '';
        if (!code) return;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
          } else {
            const textArea = document.createElement('textarea');
            textArea.value = code;
            textArea.setAttribute('readonly', '');
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
          }

          const copiedLabel = this.dataset.copiedLabel || 'Copied';
          if (this.copyText) this.copyText.textContent = copiedLabel;
          if (this.copyStatus) this.copyStatus.textContent = copiedLabel;
          window.clearTimeout(this.copyResetTimer);
          this.copyResetTimer = window.setTimeout(() => {
            if (this.copyText) this.copyText.textContent = this.dataset.copyLabel || 'Copy';
            if (this.copyStatus) this.copyStatus.textContent = '';
          }, 1800);
        } catch (error) {
          if (this.copyStatus) this.copyStatus.textContent = error.message;
        }
      }

      selectDevice(selectedOption) {
        const selectedId = selectedOption.dataset.deviceId;

        this.deviceOptions.forEach((option) => {
          const isSelected = option === selectedOption;
          option.classList.toggle('is-selected', isSelected);
          const input = option.querySelector('input');
          if (input) input.checked = isSelected;
        });

        this.mediaLayers.forEach((layer) => {
          layer.classList.toggle('is-active', layer.dataset.deviceMedia === selectedId);
        });

        const link = selectedOption.dataset.pdpLink || '';
        const label = selectedOption.dataset.ctaLabel || this.dataset.defaultCtaLabel || 'View product';
        if (this.ctaText) this.ctaText.textContent = label;
        if (!this.cta) return;

        if (link) {
          this.cta.href = link;
          this.cta.removeAttribute('aria-disabled');
          this.cta.removeAttribute('tabindex');
        } else {
          this.cta.removeAttribute('href');
          this.cta.setAttribute('aria-disabled', 'true');
          this.cta.setAttribute('tabindex', '-1');
        }
      }
    }

    customElements.define('secondary-coupon-hero', SecondaryCouponHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-listicle-faq"] && !Shopify.designMode) return;
  try {
    
  const initSecondaryListicleFaq = (root) => {
    if (!root || root.dataset.faqReady === 'true') return;
    const tabs = Array.from(root.querySelectorAll('[data-faq-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-faq-panel]'));
    if (!tabs.length || !panels.length) return;
    const activate = (category) => {
      tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.faqTab === category)));
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.faqPanel !== category;
      });
    };
    tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.faqTab)));
    root.classList.add('is-enhanced');
    activate(tabs[0].dataset.faqTab);
    root.dataset.faqReady = 'true';
  };

  document.querySelectorAll('[data-secondary-listicle-faq]').forEach(initSecondaryListicleFaq);
  document.addEventListener('shopify:section:load', (event) => {
    initSecondaryListicleFaq(event.target.querySelector('[data-secondary-listicle-faq]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-listicle-offer"] && !Shopify.designMode) return;
  try {
    
  const initSecondaryListicleOffer = (root) => {
    if (!root || root.dataset.offerReady === 'true') return;
    const slides = Array.from(root.querySelectorAll('[data-offer-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-offer-thumb]'));
    const previous = root.querySelector('[data-offer-previous]');
    const next = root.querySelector('[data-offer-next]');
    if (slides.length < 2) return;
    let activeIndex = 0;
    const show = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== activeIndex;
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', String(isActive));
      });
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    previous?.addEventListener('click', () => show(activeIndex - 1));
    next?.addEventListener('click', () => show(activeIndex + 1));
    root.dataset.offerReady = 'true';
  };

  document.querySelectorAll('[data-secondary-listicle-offer]').forEach(initSecondaryListicleOffer);
  document.addEventListener('shopify:section:load', (event) => {
    initSecondaryListicleOffer(event.target.querySelector('[data-secondary-listicle-offer]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
